/**
 * Custom code to message the client app about special cases / errors
 * @type {{ NoResultForExcelFound: number }}
 */
enum ServerCustomCode {
  NoResultForExcelFound = 1,
}
/**
 * A custom serve header to pass to the client in "special" cases where there is problem that is not a simple error.
 * @type {string}
 */
const serverCustomCodeHeaderName = "server-custom-code";

export { ServerCustomCode, serverCustomCodeHeaderName };



// WEBPACK FOOTER //
// ./src/app/_models/serverCustomCode.ts